"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactIntl = require("react-intl");
var _take = _interopRequireDefault(require("lodash/take"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _product = require("@nucleo/product");
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductSlotsBtn.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1s1elaoz44() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductSlotsBtn.js";
  var hash = "d7cb25fb0433d700cbdecd99a6774b6b948a05ea";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductSlotsBtn.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 14,
          column: 34
        }
      },
      "1": {
        start: {
          line: 16,
          column: 16
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "2": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 17,
          column: 80
        }
      },
      "3": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "4": {
        start: {
          line: 32,
          column: 19
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "5": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 35,
          column: 16
        }
      },
      "6": {
        start: {
          line: 38,
          column: 17
        },
        end: {
          line: 43,
          column: 2
        }
      },
      "7": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 42,
          column: 4
        }
      },
      "8": {
        start: {
          line: 48,
          column: 24
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "9": {
        start: {
          line: 49,
          column: 16
        },
        end: {
          line: 49,
          column: 67
        }
      },
      "10": {
        start: {
          line: 50,
          column: 20
        },
        end: {
          line: 50,
          column: 56
        }
      },
      "11": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 53,
          column: 3
        }
      },
      "12": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 87
        }
      },
      "13": {
        start: {
          line: 52,
          column: 51
        },
        end: {
          line: 52,
          column: 85
        }
      },
      "14": {
        start: {
          line: 55,
          column: 19
        },
        end: {
          line: 55,
          column: 80
        }
      },
      "15": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 57,
          column: 71
        }
      },
      "16": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 83,
          column: 4
        }
      },
      "17": {
        start: {
          line: 61,
          column: 23
        },
        end: {
          line: 61,
          column: 58
        }
      },
      "18": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 69,
          column: 10
        }
      },
      "19": {
        start: {
          line: 86,
          column: 0
        },
        end: {
          line: 97,
          column: 2
        }
      },
      "20": {
        start: {
          line: 99,
          column: 0
        },
        end: {
          line: 107,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 13
          },
          end: {
            line: 17,
            column: 14
          }
        },
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 80
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 32,
            column: 19
          },
          end: {
            line: 32,
            column: 20
          }
        },
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 35,
            column: 16
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 27
          },
          end: {
            line: 38,
            column: 28
          }
        },
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 42,
            column: 4
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 48,
            column: 24
          },
          end: {
            line: 48,
            column: 25
          }
        },
        loc: {
          start: {
            line: 48,
            column: 113
          },
          end: {
            line: 84,
            column: 1
          }
        },
        line: 48
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 37
          },
          end: {
            line: 52,
            column: 38
          }
        },
        loc: {
          start: {
            line: 52,
            column: 51
          },
          end: {
            line: 52,
            column: 85
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 24
          }
        },
        loc: {
          start: {
            line: 60,
            column: 37
          },
          end: {
            line: 70,
            column: 7
          }
        },
        line: 60
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 15
          },
          end: {
            line: 41,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 27
          }
        }, {
          start: {
            line: 41,
            column: 31
          },
          end: {
            line: 41,
            column: 49
          }
        }, {
          start: {
            line: 41,
            column: 53
          },
          end: {
            line: 41,
            column: 81
          }
        }, {
          start: {
            line: 41,
            column: 86
          },
          end: {
            line: 41,
            column: 99
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 55,
            column: 19
          },
          end: {
            line: 55,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 19
          },
          end: {
            line: 55,
            column: 41
          }
        }, {
          start: {
            line: 55,
            column: 45
          },
          end: {
            line: 55,
            column: 80
          }
        }],
        line: 55
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 52
          },
          end: {
            line: 57,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 63
          },
          end: {
            line: 57,
            column: 64
          }
        }, {
          start: {
            line: 57,
            column: 67
          },
          end: {
            line: 57,
            column: 68
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 71,
            column: 7
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 7
          },
          end: {
            line: 71,
            column: 15
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 80,
            column: 21
          }
        }],
        line: 71
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d7cb25fb0433d700cbdecd99a6774b6b948a05ea"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1s1elaoz44 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1s1elaoz44();
var _ref = (cov_1s1elaoz44().s[0]++, _stylingConstants.default),
  color = _ref.color;
var Wrapper = (cov_1s1elaoz44().s[1]++, _styledComponents.default.div.attrs({
  className: function className(props) {
    cov_1s1elaoz44().f[0]++;
    cov_1s1elaoz44().s[2]++;
    return "stx-ProductActions stx-ProductActions-".concat(props.productId);
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  padding-bottom: 0.5rem;\n  position: relative; /* to avoid to be part of clickable zone*/\n  z-index: 2; /* to avoid to be part of clickable zone*/\n"]))));
var SlotWrapper = (cov_1s1elaoz44().s[3]++, _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0.1rem;\n  display: inline-Flex;\n"]))));
cov_1s1elaoz44().s[4]++;
var SlotButton = function SlotButton(props) {
  cov_1s1elaoz44().f[1]++;
  cov_1s1elaoz44().s[5]++;
  return /*#__PURE__*/_react.default.createElement(SlotWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  })));
};
var MoreIcon = (cov_1s1elaoz44().s[6]++, (0, _styledComponents.withTheme)(function (props) {
  cov_1s1elaoz44().f[2]++;
  cov_1s1elaoz44().s[7]++;
  return /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: "more",
    iconColor: (cov_1s1elaoz44().b[0][0]++, props.theme) && (cov_1s1elaoz44().b[0][1]++, props.theme.button) && (cov_1s1elaoz44().b[0][2]++, props.theme.button.textColor) || (cov_1s1elaoz44().b[0][3]++, color.boxText),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 3
    }
  });
}));

/*
 * Component to display a list of buttons corresponding to the list of occurences of date.
 */
cov_1s1elaoz44().s[8]++;
var ProductSlotsBtn = function ProductSlotsBtn(_ref2) {
  var product = _ref2.product,
    maxOccurrences = _ref2.maxOccurrences,
    onlyAvailable = _ref2.onlyAvailable,
    onActionClick = _ref2.onActionClick,
    ecommerceGoogleTracking = _ref2.ecommerceGoogleTracking;
  cov_1s1elaoz44().f[3]++;
  var props = (cov_1s1elaoz44().s[9]++, {
    onActionClick: onActionClick,
    product: product,
    ecommerceGoogleTracking: ecommerceGoogleTracking
  });
  var occurrences = (cov_1s1elaoz44().s[10]++, _product.ProductModel.getOccurrences(product));
  cov_1s1elaoz44().s[11]++;
  if (onlyAvailable) {
    cov_1s1elaoz44().b[1][0]++;
    cov_1s1elaoz44().s[12]++;
    occurrences = occurrences.filter(function (occurrence) {
      cov_1s1elaoz44().f[4]++;
      cov_1s1elaoz44().s[13]++;
      return occurrence.availability !== 'NONE';
    });
  } else {
    cov_1s1elaoz44().b[1][1]++;
  }
  // define if we will show the "more" button
  var showMore = (cov_1s1elaoz44().s[14]++, (cov_1s1elaoz44().b[2][0]++, occurrences.length > 0) && (cov_1s1elaoz44().b[2][1]++, occurrences.length > maxOccurrences));
  // if there is the need of show more, remove one occurrence to show the show more button
  cov_1s1elaoz44().s[15]++;
  occurrences = (0, _take.default)(occurrences, maxOccurrences - (showMore ? (cov_1s1elaoz44().b[3][0]++, 1) : (cov_1s1elaoz44().b[3][1]++, 0)));
  cov_1s1elaoz44().s[16]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }, occurrences.map(function (occurrence) {
    cov_1s1elaoz44().f[5]++;
    var action = (cov_1s1elaoz44().s[17]++, (0, _values.default)(occurrence.action)[0]);
    cov_1s1elaoz44().s[18]++;
    return /*#__PURE__*/_react.default.createElement(SlotButton, (0, _extends2.default)({
      key: action,
      small: true
    }, _ProductHelper.default.getActionHandler(props, product.id, action), {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 11
      }
    }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedTime, {
      value: occurrence.start,
      timeZone: "UTC",
      hour12: false,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 13
      }
    }));
  }), (cov_1s1elaoz44().b[4][0]++, showMore) && (cov_1s1elaoz44().b[4][1]++, /*#__PURE__*/_react.default.createElement(SlotButton, (0, _extends2.default)({
    small: true
  }, _ProductHelper.default.getActionHandler(props, product.id, (0, _values.default)(product.action)[0]), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react.default.createElement(MoreIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 11
    }
  }))));
};
cov_1s1elaoz44().s[19]++;
ProductSlotsBtn.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* The product object to display */
  maxOccurrences: _propTypes.default.number,
  /* Display only buttons for which we are that there is enough availability */
  onlyAvailable: _propTypes.default.bool,
  /** Custom handler for action */
  onActionClick: _propTypes.default.bool,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({})
};
cov_1s1elaoz44().s[20]++;
ProductSlotsBtn.defaultProps = {
  onlyAvailable: true,
  maxOccurrences: 99,
  onActionClick: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  }
};
var _default = exports.default = ProductSlotsBtn;